import { payment_type_card, payment_type_upi } from "../../constant/constant";

export const SET_LOADER = "SET_LOADER";
export const IS_COMPLETE = "IS_COMPLETE";
export const IS_CARD = "IS_CARD";
export const IS_DELIVERY = "IS_DELIVERY";
export const IS_NEW_ADDRESS = "IS_NEW_ADDRESS";
export const IS_PAYMENT_OPEN = "IS_PAYMENT_OPEN";
export const SET_SHOW_STORE_NAME_IN_HEADER = "SET_SHOW_STORE_NAME_IN_HEADER";
export const SET_PAYMENT_OPTION_TYPE = "SET_PAYMENT_OPTION_TYPE";

export const SET_IS_SHOW_MOBILE_SEARCH = "SET_IS_SHOW_MOBILE_SEARCH";
export const SET_IS_SHOW_WEB_SEARCH="SET_IS_SHOW_WEB_SEARCH"

export const SETISSHOWWEBSEARCH = (data: any) => {
  return {
    type: SET_IS_SHOW_WEB_SEARCH,
    payload: data
  }
}

export const SETISSHOWMOBILESEARCH = (data: any) => {
  return {
    type: SET_IS_SHOW_MOBILE_SEARCH,
    payload: data
  }
}

export const SETPAYMENTOPTIONTYPE = (data: any) => {
  return {
    type: SET_PAYMENT_OPTION_TYPE,
    payload: data
  }
}
export const SETLOADER = (data: any) => {
  return {
    type: SET_LOADER,
    payload: data,
  };
};
export const SETSHOWSTORENAMEINHEADER = (data: any) => {
  return {
    type: SET_SHOW_STORE_NAME_IN_HEADER,
    payload: data,
  };
};

export const SETISCARD = (data: any) => {
  return {
    type: IS_CARD,
    payload: data,
  };
};
export const SETISCOMPLETE = (data: any) => {
  return {
    type: IS_COMPLETE,
    payload: data,
  };
};
export const SETISDELIVERY = (data: any) => {
  return {
    type: IS_DELIVERY,
    payload: data,
  };
};
export const SETISNEWADDRESS = (data: any) => {
  return {
    type: IS_NEW_ADDRESS,
    payload: data,
  };
};
export const SETISPAYMENTOPEN = (data: any) => {
  return {
    type: IS_PAYMENT_OPEN,
    payload: data,
  };
};
const initialState: object = {
  loader: false,
  isComplete: false,
  isCard: false,
  isDelivery: false,
  newAddress: true,
  paymentOpen: false,
  isShowStoreNameHeader: false,
  isShowMobileSearch: false,
  isShowWebSearch:false,
  paymentOptionType: payment_type_upi,
};

const reducer = (state = initialState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case SET_IS_SHOW_WEB_SEARCH:
      return {
        ...state,
        isShowWebSearch:payload
      }
    case SET_IS_SHOW_MOBILE_SEARCH:
      return {
        ...state,
        isShowMobileSearch: payload,
      }
    case SET_PAYMENT_OPTION_TYPE:
      return {
        ...state,
        paymentOptionType: payload
      }
    case SET_SHOW_STORE_NAME_IN_HEADER:
      return {
        ...state,
        isShowStoreNameHeader: payload
      }
    case SET_LOADER:
      return {
        ...state,
        loader: payload,
      };
    case IS_COMPLETE:
      return {
        ...state,
        isComplete: payload,
      };
    case IS_CARD:
      return {
        ...state,
        isCard: payload,
      };
    case IS_DELIVERY:
      return {
        ...state,
        isDelivery: payload,
      };
    case IS_NEW_ADDRESS:
      return {
        ...state,
        newAddress: payload,
      };
    default:
      return state;
  }
};

export default reducer;
